import { render, staticRenderFns } from "./MessageIssued.vue?vue&type=template&id=8070452a&scoped=true&"
import script from "./MessageIssued.vue?vue&type=script&lang=js&"
export * from "./MessageIssued.vue?vue&type=script&lang=js&"
import style0 from "./MessageIssued.vue?vue&type=style&index=0&id=8070452a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8070452a",
  null
  
)

export default component.exports